export default [
  {
    conditions: [1, 4],
    heading: "questionnaire",
    questions: [
      {
        id: 1,
        text: "iq_education",
        value: {},
        options: [
          {
            value: { points: 2, text: "iq_education_higher" }
          },
          {
            value: { points: 0, text: "iq_education_secondary" }
          },
          {
            value: { points: -2, text: "iq_education_primary" }
          }
        ]
      },
      {
        id: 2,
        text: "iq_is_education_economic",
        value: {},
        options: [
          {
            value: { points: 3, text: "yes" }
          },
          {
            value: { points: 0, text: "no" }
          }
        ]
      },
      {
        id: 3,
        text: "iq_main_income_source",
        input: {
          label: "iq_main_income_source_label",
          type: "text",
          placeholder: "iq_main_income_source_placeholder",
          required: true,
          hidden: true,
          value: ""
        },
        value: [],
        options: [
          {
            value: { points: 1, text: "employee", showInput: true }
          },
          {
            value: { points: 1, text: "self_employed", showInput: true }
          },
          {
            value: { points: 1, text: "entrepreneur", showInput: true }
          },
          {
            value: { points: -1, text: "student" }
          },
          {
            value: { points: -1, text: "pensioner" }
          },
          {
            value: { points: -3, text: "unemployed" }
          }
        ]
      },
      {
        id: 4,
        text: "iq_politically_exposed_person",
        value: {},
        options: [
          {
            value: { points: 0, text: "yes" }
          },
          {
            value: { points: 0, text: "no" }
          }
        ]
      },
      {
        id: 5,
        text: "iq_investment_intention",
        value: {},
        options: [
          {
            value: { points: 2, text: "asset_appreciation" }
          },
          {
            value: { points: 0, text: "capital_protection" }
          },
          {
            value: { points: 2, text: "regular_savings" }
          }
        ]
      },
      {
        id: 6,
        text: "iq_investment_period",
        value: {},
        options: [
          {
            value: { points: 0, text: "iq_investment_period_short" }
          },
          {
            value: { points: 3, text: "iq_investment_period_medium" }
          },
          {
            value: { points: 5, text: "iq_investment_period_long" }
          }
        ]
      },
      {
        id: 7,
        text: "iq_accepted_level_of_risk",
        value: {},
        input: null,
        options: [
          {
            value: { points: 0, text: "low_female" }
          },
          {
            value: { points: 1, text: "medium_female" }
          },
          {
            value: { points: 3, text: "high_female" }
          }
        ]
      },
      {
        id: 8,
        text: "iq_expected_return",
        value: {},
        options: [
          {
            value: { points: 0, text: "low_male" }
          },
          {
            value: { points: 1, text: "medium_male" }
          },
          {
            value: { points: 3, text: "high_male" }
          }
        ]
      },
      {
        id: 9,
        text: "iq_stress_scenario",
        values: {},
        options: [
          {
            value: {
              points: -2,
              text: "iq_stress_scenario_immediate_sell"
            }
          },
          {
            value: {
              points: 0,
              text: "iq_stress_scenario_wait_then_sell"
            }
          },
          {
            value: {
              points: 3,
              text: "iq_stress_scenario_keep_calm"
            }
          }
        ]
      },
      {
        id: 10,
        text: "iq_loss_of_planned_investment",
        value: {},
        options: [
          {
            value: {
              points: 0,
              text: "iq_loss_of_planned_investment_without_impact"
            }
          },
          {
            value: {
              points: -1,
              text: "iq_loss_of_planned_investment_minor_impact"
            }
          },
          {
            value: {
              points: -3,
              text: "iq_loss_of_planned_investment_major_impact"
            }
          }
        ]
      },
      {
        id: 11,
        text: "iq_invested_amount_is",
        value: {},
        options: [
          {
            value: {
              points: 0,
              text: "iq_invested_amount_is_my_capital"
            }
          },
          {
            value: {
              points: -8,
              text: "iq_invested_amount_is_loan"
            }
          }
        ]
      },
      {
        id: 12,
        text: "iq_yearly_savings_amount",
        value: {},
        options: [
          {
            value: { points: 6, text: "iq_yearly_savings_amount_high" }
          },
          {
            value: {
              points: 1,
              text: "iq_yearly_savings_amount_medium"
            }
          },
          {
            value: { points: 0, text: "less" }
          }
        ]
      },
      {
        id: 13,
        multiple: true,
        text: "iq_known_securities",
        value: [],
        options: [
          {
            value: {
              points: 1,
              text: "funds"
            }
          },
          {
            value: {
              points: 2,
              text: "shares_and_etf"
            }
          },
          {
            value: { points: 1, text: "bonds" }
          },
          {
            value: { points: 0, text: "dunno" }
          }
        ]
      }
    ]
  }
];
